import React from "react";
import { Box, Text, Heading, Stack, Container } from "@chakra-ui/react";
import { PageContainer } from "../src/components/ui/PageContainer";
import { GetStaticProps } from "next";
import { HeroWrapper } from "../src/components/ContentPages/HeroWrapper";
import { Layout } from "../src/components/Layout";

export default function Imprint() {
  return (
    <Layout
      pageTitle={`mentorlab | Impressum`}
      pageDescription={""}
      og={{
        currentRelativeUrlPath: `/imprint`,
        siteName: "mentorlab | Impressum",
      }}
    >
      <PageContainer>
        <Container maxW={"7xl"} mt={10}>
          <HeroWrapper
            title={"Impressum"}
            subTitle={""}
            imgUrl={"/mission.svg"}
            imgAltText={"mentorlab impressum illustration"}
          />
          <Stack alignItems="center" spacing={20}>
            <Box maxW="3xl" mt={20} w="100%">
              <Heading as="h2" fontSize="lg" mb={5}>
                Angaben gemäß § 5 TMG
              </Heading>
              <Text>
                Mentorlab
                <br />
                Leopoldstr. 256
                <br />
                c/o MST Group
                <br />
                80807 München
              </Text>
              <br />
              <Text>
                <strong>Vertreten durch:</strong>
                <br />
                Florian Birnkammer,
                <br />
                Mike Schertl,
                <br />
                Alexander Sattler
              </Text>
              <br />
              <Heading as="h2" fontSize="lg">
                Kontakt
              </Heading>

              <Text>
                Telefon: +491636938484
                <br />
                E-Mail: team@mentorlab.de
              </Text>
              <br />
              <Heading as="h2" fontSize="lg">
                EU-Streitschlichtung
              </Heading>

              <Text>
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{" "}
                <a
                  href="https://ec.europa.eu/consumers/odr/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  https://ec.europa.eu/consumers/odr/
                </a>
                .<br /> Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </Text>
              <br />
              <Heading as="h2" fontSize="lg">
                Verbraucher­streit­beilegung/Universal­schlichtungs­stelle
              </Heading>

              <Text>
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </Text>
            </Box>
          </Stack>
        </Container>
      </PageContainer>
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async (_context) => {
  return {
    props: {},
  };
};
